import { render, staticRenderFns } from "./MicrocartIcon.vue?vue&type=template&id=54908204&scoped=true&"
import script from "./MicrocartIcon.vue?vue&type=script&lang=js&"
export * from "./MicrocartIcon.vue?vue&type=script&lang=js&"
import style0 from "./MicrocartIcon.vue?vue&type=style&index=0&id=54908204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54908204",
  null
  
)

export default component.exports